import { ALLOCATION_DIMENSION } from "constants/action-types";
import { Observable } from "rxjs";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { ListAllocationDimensionRequestAction, listAllocationDimensionComplete } from "actions/allocation-dimension";
import { formatMessage } from "lib/globalize-util";
import { AllocationDimensionOwnerObject } from "helpers/allocation-dimension";

import { add as snackbarAdd } from "actions/snackbars";

export const listAllocationDimensions = (action$: ActionsObservable<ListAllocationDimensionRequestAction>) =>
    action$
        .ofType(ALLOCATION_DIMENSION.LIST.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ objectId, owner }) => {
            let path;
            switch (owner) {
                case AllocationDimensionOwnerObject.Merchant:
                    path = `${siteConfig.goAPI}/v1/collections/merchants/${objectId}/allocation_dimensions`;
                    break;
                default:
                    return [listAllocationDimensionComplete(new Error(`Unknown owner type: ${owner}`))];
            }

            return ajax(path)
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    return [listAllocationDimensionComplete(response.data)];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of(listAllocationDimensionComplete(error)),
                        Observable.of(
                            snackbarAdd({
                                message: error.message || formatMessage("Error getting allocation dimensions"),
                            }),
                        ),
                    ),
                );
        });
